import { render, staticRenderFns } from "./LeagueList.vue?vue&type=template&id=73920fb3&"
import script from "./LeagueList.vue?vue&type=script&lang=js&"
export * from "./LeagueList.vue?vue&type=script&lang=js&"
import style0 from "./LeagueList.vue?vue&type=style&index=0&id=73920fb3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports